// ============================================================
// Clinic Bundle - Constants & Enum
// Tập trung tất cả data cứng của module clinic_bundle
// ============================================================

// ----------------------------------------------------------
// Loại sản phẩm / dịch vụ (dùng trong ServicesProducts.vue)
// ----------------------------------------------------------
export const PRODUCT_TYPE = {
    MEDICINE: 'MEDICINE',
    SERVICE_PACKAGE: 'SERVICE_PACKAGE',
    SERVICE: 'SERVICE',
};

/** Thứ tự tab tương ứng với PRODUCT_TYPE */
export const TAB_TYPE_MAP = [
    PRODUCT_TYPE.MEDICINE,
    PRODUCT_TYPE.SERVICE_PACKAGE,
    PRODUCT_TYPE.SERVICE,
];

/** Tên hiển thị của từng loại */
export const PRODUCT_TYPE_NAMES = {
    [PRODUCT_TYPE.MEDICINE]: 'thuốc & TPCN',
    [PRODUCT_TYPE.SERVICE_PACKAGE]: 'gói dịch vụ',
    [PRODUCT_TYPE.SERVICE]: 'dịch vụ khám',
};

/** Placeholder tìm kiếm theo loại */
export const SEARCH_PLACEHOLDERS = {
    [PRODUCT_TYPE.MEDICINE]: 'Tìm kiếm thuốc & TPCN...',
    [PRODUCT_TYPE.SERVICE_PACKAGE]: 'Tìm kiếm gói dịch vụ...',
    [PRODUCT_TYPE.SERVICE]: 'Tìm kiếm dịch vụ khám...',
};

/** Icon flaticon theo loại */
export const PRODUCT_TYPE_ICONS = {
    [PRODUCT_TYPE.MEDICINE]: 'flaticon2-medical-records',
    [PRODUCT_TYPE.SERVICE_PACKAGE]: 'flaticon2-layers-1',
    [PRODUCT_TYPE.SERVICE]: 'flaticon2-cardiogram',
};

/** Route tạo mới theo loại */
export const CREATE_ROUTES = {
    [PRODUCT_TYPE.MEDICINE]: { name: 'medicine_create' },
    [PRODUCT_TYPE.SERVICE_PACKAGE]: { name: 'service_package_create' },
    [PRODUCT_TYPE.SERVICE]: { name: 'service_create' },
};


export const PAGE_SIZE_OPTIONS = [
    { value: 5, text: '5' },
    { value: 10, text: '10' },
    { value: 25, text: '25' },
    { value: 50, text: '50' },
];

// ----------------------------------------------------------
// Danh mục dịch vụ (dùng trong ServiceForm.vue)
// ----------------------------------------------------------
export const SERVICE_CATEGORY_OPTIONS = [
    { value: 1, text: 'Đặt lịch' },
    { value: 2, text: 'Giới thiệu đối tác' },
    { value: 3, text: 'Báo cáo' },
    { value: 4, text: 'DSP' },
    { value: 5, text: 'Mua thuốc' },
    { value: 6, text: 'Xét nghiệm' },
];

// ----------------------------------------------------------
// Tính năng app (dùng trong ServiceForm.vue, ServicesProducts.vue)
// ----------------------------------------------------------
export const APP_FEATURE_OPTIONS = [
    { value: 0, text: 'Không' },
    { value: 1, text: 'Khám từ xa (Online)' },
    { value: 2, text: 'Đặt lịch (Offline)' },
    { value: 3, text: 'Ưu đãi' },
    { value: 4, text: 'Báo cáo' },
    { value: 5, text: 'Mua thuốc' },
    { value: 6, text: 'Xét nghiệm' },
];

// ----------------------------------------------------------
// Đăng ký gần đây mẫu (dùng trong ClinicDashboard.vue)
// ----------------------------------------------------------
export const SAMPLE_RECENT_REGISTRATIONS = [
    {
        name: 'Gói Khám Định Kỳ',
        customer: 'cust4',
        date: '1/2/2026',
        status: 'Hoạt động',
    },
    {
        name: 'Gói Chăm Sóc Da & Chống Lão Hóa',
        customer: 'cust3',
        date: '25/1/2026',
        status: 'Hoạt động',
    },
    {
        name: 'Gói Giảm Cân & Detox',
        customer: '',
        date: '',
        status: 'Hoạt động',
    },
];

// ----------------------------------------------------------
// Gói đang bán mẫu (dùng trong ClinicDashboard.vue)
// ----------------------------------------------------------
export const SAMPLE_AVAILABLE_PACKAGES = [
    {
        name: 'Gói Chăm Sóc Sức Khỏe Toàn Diện',
        price: 15000000,
        discount: '-25%',
    },
    {
        name: 'Gói Giảm Cân & Detox',
        price: 18000000,
        discount: '-25%',
    },
    {
        name: 'Gói Chăm Sóc Da & Chống Lão Hóa',
        price: 12000000,
        discount: '-25%',
    },
];

// ----------------------------------------------------------
// Danh sách gói dịch vụ mẫu (dùng trong PackageManagement.vue)
// ----------------------------------------------------------
export const SAMPLE_PACKAGES = [
    {
        id: 1,
        name: 'Gói Khám Định Kỳ',
        description: 'Gói khám sức khỏe định kỳ co bản',
        currentPrice: 5000000,
        originalPrice: 7000000,
        discount: -29,
        months: 1,
        sessions: 0,
        services: 3,
        duration: '6 tháng',
        createdDate: '10/1/2026',
        status: 'Hoạt động',
    }
];
